<template>
    <section class="boxSection">
        <h1 class="text-center">UNDER MAINTENANCE...</h1>
        <div class="text-center my-5">
            <h1 style="font-family: 'Bungee', cursive;">My History</h1>
        </div>
        <div>
            <div class="container my-5">
                <TransactionTable></TransactionTable>
            </div>
        </div> -->
    </section>
</template>

<script>
 import TransactionTable from '../components/TransactionTable.vue';

export default {
  name: 'Transaction',
   components: {
     TransactionTable,
   },
}
</script>

<style>

</style>
